module.exports = __webpack_public_path__ + "static/media/lease-truck-program-4.a0c69865.png";